import React from "react";
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import "../../scss/dashboard/dashboardindex1.css";
import DashMenu from "./Dashmenu";
import DashInicio from "./dashInicio";
import DashInicioAlt from "./DashInicioAlt";
import DashMisPlantillas from "./dashMisPlantillas";
import CrearPlantillas from "./crearPlantillas";
import PlantillasVendidas from "./PlantillasVendidas";
import DashSettings from "./dashSettings";
import EditarPlantilla from "./editarPlantilla";
// import DashInicio from "./dashInicio";
function DashboardIndex() {
  const { path } = useRouteMatch();

  console.log({path})
  
  return (
    <section
      style={{
        width: "100vw",
        margin: "0px",
        maxWidth: "100%",
        padding: "0px",
        display: "flex",
        overflowX: 'hidden',
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div className="dashboardIndex">
        <DashMenu />
        <Switch>
          <Route path={`${path}/templates/create`}>
            <CrearPlantillas />
          </Route>
          <Route path={`${path}/templates/:templateId/edit`}>
            <EditarPlantilla />
          </Route>
          <Route path={`${path}/templates/sold`}>
            <PlantillasVendidas />
          </Route>
          <Route path={`${path}/templates`}>
            <DashMisPlantillas />
          </Route>
          <Route path={`${path}/settings`}>
            <DashSettings />
          </Route>
          <Route path={`${path}/alt`} exact component={DashInicioAlt} />
          <Route path={path} exact component={DashInicio} />
          
        </Switch>
      </div>
    </section>
  );
}

export default DashboardIndex;
